/**
 * SOFINE Theme JS
 * Philharmonia Orchestra Shopify Theme
 */

(function() {
  'use strict';

  /* -------------------------------------------------------------------------
     Header: Scroll state (adds shadow + compact mode)
     ------------------------------------------------------------------------- */
  var header = document.getElementById('site-header');
  var lastScrollY = 0;
  var ticking = false;

  function onScroll() {
    lastScrollY = window.scrollY;
    if (!ticking) {
      window.requestAnimationFrame(function() {
        if (lastScrollY > 50) {
          header.classList.add('scrolled');
          document.body.classList.add('has-scrolled');
        } else {
          header.classList.remove('scrolled');
          document.body.classList.remove('has-scrolled');
        }
        ticking = false;
      });
      ticking = true;
    }
  }

  if (header) {
    window.addEventListener('scroll', onScroll, { passive: true });
  }


  /* -------------------------------------------------------------------------
     Mobile Navigation Toggle
     ------------------------------------------------------------------------- */
  var mobileToggle = document.getElementById('mobile-toggle');
  var navMobile = document.getElementById('nav-mobile');

  if (mobileToggle && navMobile) {
    mobileToggle.addEventListener('click', function() {
      var isOpen = document.body.classList.toggle('nav-open');
      mobileToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

      if (isOpen) {
        // Prevent body scroll when nav is open
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    });

    // Close nav on escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && document.body.classList.contains('nav-open')) {
        document.body.classList.remove('nav-open');
        mobileToggle.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
        mobileToggle.focus();
      }
    });
  }

})();


/* Product card reveal — staggered entrance on scroll */
(function() {
  var cards = document.querySelectorAll('.product-card');
  if (!cards.length) return;

  // No IntersectionObserver support? Just show everything.
  if (!('IntersectionObserver' in window)) {
    cards.forEach(function(c) { c.classList.add('is-visible'); });
    return;
  }

  var observer = new IntersectionObserver(function(entries, obs) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        var el = entry.target;
        var siblings = Array.prototype.slice.call(el.parentElement.children);
        var idx = siblings.indexOf(el);
        el.style.transitionDelay = (idx % 4) * 80 + 'ms';  // cascade across each row
        el.classList.add('is-visible');
        obs.unobserve(el);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

  cards.forEach(function(c) { observer.observe(c); });
})();